module.exports = __webpack_public_path__ + "img/Stopwatch.e1e65c8ab.svg";